/**
 * Possible order statuses returned by the API,
 * mapped to display labels and timeline step numbers.
 * The API returns uppercase statuses (PENDING, CONFIRMED, etc.).
 */
export const ORDER_STATUSES = {
  // Uppercase — from API / normalizeOrder
  PENDING:    { label: 'Order Placed',     step: 1 },
  ACCEPTED:   { label: 'Accepted',         step: 2 },
  CONFIRMED:  { label: 'Confirmed',        step: 2 },
  PROCESSING: { label: 'Being Prepared',   step: 3 },
  SHIPPED:    { label: 'Out for Delivery', step: 4 },
  DELIVERED:  { label: 'Delivered',        step: 5 },
  CANCELLED:  { label: 'Cancelled',        step: 0 },
  // Lowercase aliases (legacy / mock data)
  pending:    { label: 'Order Placed',     step: 1 },
  accepted:   { label: 'Accepted',         step: 2 },
  confirmed:  { label: 'Confirmed',        step: 2 },
  processing: { label: 'Being Prepared',   step: 3 },
  shipped:    { label: 'Out for Delivery', step: 4 },
  delivered:  { label: 'Delivered',        step: 5 },
  cancelled:  { label: 'Cancelled',        step: 0 },
};

export const getOrderStatusLabel = (status) => {
  if (!status) return "";
  const normalized = String(status).trim().toUpperCase();
  return ORDER_STATUSES[normalized]?.label
    ?? normalized.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export const TIMELINE_STEPS = [
  { step: 1, label: 'Order Placed'     },
  { step: 2, label: 'Confirmed'        },
  { step: 3, label: 'Being Prepared'   },
  { step: 4, label: 'Out for Delivery' },
  { step: 5, label: 'Delivered'        },
];
